import React, { Component, Fragment } from 'react'
import TextInput from 'components/UI/TextInput'
import { ContentBlock } from 'components/common'
import Dropdown from '../../UI/Dropdown'
import { Col, Row } from 'styled-bootstrap-grid'
import { Button } from '../../UI/Button'
import { FormTitle, AddressBlock, BottomBlock, Form } from './styles'
import { ProfilePayloadType } from '../../../ducks/profile/types'
import { history, routePath } from '../../../routes'
import PhoneSelector from '../../UI/PhoneInput/PhoneInput'

interface ProfileState {
  profile: ProfilePayloadType
}

interface Props {
  profile: ProfilePayloadType
  onSaveProfile: any // describe func
  genders: any
}

class ProfileForm extends Component<Props, ProfileState> {
  constructor(props: Props) {
    super(props)
    this.state = {
      profile: props.profile
    }
  }
  componentDidUpdate(prevProps: any) {
    if (prevProps.profile !== this.props.profile) {
      const profile = {
        ...this.props.profile,
        gender: {
          value: this.props.profile.gender,
          label: this.props.profile.gender
        }
      }
      this.setState({ profile })
    }
  }
  onUpdate = (name: string, value: string) => {
    console.log("onUpdate", name, value)
    this.setState({
      profile: {
        ...this.state.profile,
        [name]: value
      }
    })
  }
  onSubmit = () => {
    const profile = { ...this.state.profile }
    if (profile.dob) {
      const [m, d, y] = profile.dob.split('/')
      profile.dob = `${y}-${m}-${d}`
    } /* else {
      handleErrorMessageAlert("Date of birth property can't be empty!")
    } */
    if (profile.gender) {
      // @ts-ignore
      profile.gender = profile.gender.value ? profile.gender.value : ''
    }
    // if (profile.phoneNumber) {
    //   const [m, d, y] = profile.dob.split('/')
    //   profile.dob = `${y}-${m}-${d}`
    // } else {
    //   handleErrorMessageAlert("Date of birth property can't be empty!")
    // }
    console.log('profile', profile)
    this.props.onSaveProfile({ profile })
  }
  onCancel = () => {
    this.setState({ profile: { ...this.state.profile, ...this.props.profile } })
  }
  goBack = () => {
    history.push(routePath.ESTIMATES_PAGE)
  }

  render() {
    const {
      profile: {
        firstName,
        lastName,
        dob,
        street,
        city,
        state,
        zipCode,
        gender,
        mobileNumber
      }
    } = this.state
    const { genders } = this.props
    return (
      <Fragment>
        <ContentBlock>
          <Form>
            <div>
              <FormTitle>Profile</FormTitle>
              <TextInput
                name={'firstName'}
                value={firstName}
                label={'First Name'}
                placeholder={'Enter First Name'}
                // errorLabel={errors.firstName || ''}
                handleChange={this.onUpdate}
              />
              <TextInput
                name={'lastName'}
                value={lastName}
                label={'Last Name'}
                placeholder={'Enter Last Name'}
                // errorLabel={errors.lastName || ''}
                handleChange={this.onUpdate}
              />
              {/*<TextInput*/}
              {/*  name={'mobileNumber'}*/}
              {/*  value={mobileNumber}*/}
              {/*  label={'Phone Number (optional)'}*/}
              {/*  placeholder={'Enter Phone Number'}*/}
              {/*  handleChange={this.onUpdate}*/}
              {/*/>*/}
              <PhoneSelector
                label={'Phone Number (optional)'}
                placeholder="Enter phone number"
                name={'mobileNumber'}
                value={mobileNumber}
                onChange={this.onUpdate}
              />
              <TextInput
                name={'dob'}
                value={dob}
                label={'Date of Birth'}
                placeholder={'Enter MM/DD/YYYY'} // YYYY-MM-DD
                type={'date'}
                // errorLabel={errors.lastName || ''}
                handleChange={this.onUpdate}
              />
              <Dropdown
                name={'gender'}
                options={genders}
                label={'Gender'}
                placeholder={'Select Gender'}
                hideControl={true}
                onSelect={this.onUpdate}
                value={gender}
                // onInputChange={this.test}
              />
            </div>

            <AddressBlock>
              <FormTitle>Address</FormTitle>

              <TextInput
                name={'street'}
                value={street}
                label={'Street'}
                placeholder={'Enter Full Street Address'}
                // errorLabel={errors.firstName || ''}
                handleChange={this.onUpdate}
              />
              <Row>
                <Col lg={6}>
                  <TextInput
                    name={'city'}
                    value={city}
                    label={'City'}
                    placeholder={'Enter City'}
                    // errorLabel={errors.firstName || ''}
                    handleChange={this.onUpdate}
                  />
                </Col>
                <Col lg={6}>
                  <TextInput
                    name={'state'}
                    value={state}
                    label={'State'}
                    placeholder={'Enter State'}
                    // errorLabel={errors.firstName || ''}
                    handleChange={this.onUpdate}
                  />
                </Col>
                <Col lg={6}>
                  <TextInput
                    name={'zipCode'}
                    value={zipCode}
                    label={'Zip Code'}
                    placeholder={'Enter Zip Code'}
                    // errorLabel={errors.firstName || ''}
                    handleChange={this.onUpdate}
                  />
                </Col>
              </Row>
            </AddressBlock>
          </Form>
        </ContentBlock>
        <BottomBlock>
          <Button variant={'secondary'} onClick={this.goBack}>
            Cancel
          </Button>
          <Button variant={'default'} onClick={this.onSubmit}>
            Save
          </Button>
        </BottomBlock>
      </Fragment>
    )
  }
}

export default ProfileForm
